<template>
  <!-- 奖品列表 -->
  <div class="prizeList">
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="handleRefresh" :crumbsList="['抽奖管理',$route.meta.title]">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-document-add" @click="handleEdit('')">新增奖品</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input style="width:200px;margin-right:5px" clearable placeholder="输入关键字" v-model="searchForm.name">
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table :data="tableData" stripe border height="calc(100% - 130px)" tooltip-effect="dark" style="width: 100%">
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="id" show-overflow-tooltip label="奖品编号">
      </el-table-column>
      <el-table-column align="center" prop="img" label="奖品图片">
        <template slot-scope="scope">
          <img-view :imgList="[{ url: scope.row.img, id: 0 }]"></img-view>
        </template>
      </el-table-column>
      <el-table-column prop="name" align="center" show-overflow-tooltip label="奖品名称">
      </el-table-column>
      <el-table-column prop="type" label="奖品类型" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="value" label="奖品价值/优惠券编号" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="lastTime" label="最后修改时间" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" plain style="padding:2px 3px;" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" plain style="padding:2px 3px;" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage" @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"></pagination>

    <!-- 添加管理员 -->
    <el-drawer :visible.sync="addDrawer" :withHeader="false" :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal" direction="rtl">
      <div class="drawer-header">
        奖品信息
      </div>
      <el-scrollbar style="height:calc(100% - 90px);">
        <div class="drawer-form-wrap">
          <el-form :model="addForm" label-position="rigth" label-width="100px" :rules="formRule" ref="addForm">
            <el-form-item label="奖品分类" prop="type">
              <el-select v-model="addForm.type" style="width: 100%;">
                <el-option v-for="(item, index) in typeList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-show="addForm.type == '实体物品'" label="请选择奖品" prop="coupon" class="el-form-required-true">
              <el-input v-model="addForm.value" readonly @click.native="getGoods" placeholder="单击选择"></el-input>
            </el-form-item>
            <el-form-item label="奖品标题" prop="name">
              <el-input v-model="addForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="封面图" prop="img">
              <!-- 图片预览组件 -->
              <img-view :imgList="[{ url: addForm.img, id: 0 }]"></img-view>
              <!-- 文件上传组件 -->
              <upload @fileChange="uploadImg" accept="image/jpg,image/jpeg,image/png"></upload>
            </el-form-item>
            <el-form-item v-show="addForm.type == '优惠券'" label="优惠券" prop="coupon" class="el-form-required-true">
              <el-input v-model="addForm.coupon" readonly @click.native="getCoupon('')" placeholder="单击选择"></el-input>
            </el-form-item>
            <!-- <el-form-item v-show="addForm.type == '实体物品' || addForm.type == '会员积分'"
              :label="addForm.type == '实体物品' ? '数量' : '积分'" prop="value" class="el-form-required-true">
              <el-input-number v-model="addForm.value" style="width: 200px;" :min="0"></el-input-number>
            </el-form-item> -->
            <el-form-item v-if="addForm.type == '会员积分'"
              label="积分" prop="value" class="el-form-required-true">
              <el-input-number v-model="addForm.value" style="width: 200px;" :min="0"></el-input-number>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <!-- 数据选择 -->
    <tableDialog v-if="dialogVisible" :title="'优惠券列表'" :isMoreSel="false" :searchValue="searchCoupon.name"
      :tableData="tableList" :tableHead="tableDataHead" :currPage.sync="currPageCoupon" :allPage="allPageCoupon"
      @search="getCoupon" @rowClick="rowClick" @hanCurrChange="hanCurrChangeCoupon" @close="dialogVisible = false">
    </tableDialog>

    <!-- 商品列表 -->
    <el-dialog title="商品列表" :visible.sync="goodsDialog" width="70%">
      <search-bar>
        <template>
          <el-input style="width: 200px; margin-right: 5px" clearable placeholder="输入商品名称" v-model="goodsName">
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="getGoods">搜索</el-button>
        </template>
      </search-bar>
      <el-table :data="goodsList" height="300" stripe border tooltip-effect="dark">
        <el-table-column label="序号" align="center" width="50" type="index">
        </el-table-column>
        <el-table-column align="center" label="商品id" prop="goodsid" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" label="商品名称" prop="goodsname" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="生产厂家" prop="drug_factory" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="package_unit" label="规格" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="package_unit" label="规格" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>
              <el-button type="text" @click="handleGoods(scope)">选择</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: 'prizeList',
  data() {
    return {
      /**表格数据 */
      // {
      //   id: "编号",
      //   img: "图片",
      //   name: "名称",
      //   type: "类型",
      //   value: "价值",
      //   lastTime: "最后修改时间"
      // }
      tableData: [],
      /**搜索表单 */
      searchForm: {
        name: ""
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,/**新增管理员drawer */
      addDrawer: false,
      /**表单数据 */
      addForm: {
        id: "", // 奖品ID
        type: '', // 奖品分类
        name: "", // 奖品名称
        img: "", // 奖品图片
        coupon: '', // 优惠券
        value: '', // 商品价值
      },
      /**表单验证 */
      formRule: {
        type: [mustFill],
        name: [mustFill],
        img: [mustFill],
      },
      typeList: [],
      // 优惠券选择弹框相关
      searchCoupon: {
        name: '',
      },
      dialogVisible: false,
      currPageCoupon: 1,
      allPageCoupon: 0,
      tableList: [],
      tableDataHead: {},

      /**积分商城商品 */
      goodsName: "",// 搜索名称
      goodsDialog: false,
      goodsList: []
    }
  },
  mounted() {
    this.getTableData()
    this.getType()
  },
  methods: {
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage
      this.$request({
        method: 'get',
        url: "Prize/GetPrizeList?keyword=" + this.searchForm.name + "&pageSize=" + this.pageSize + "&pageIndex=" + this.currPage + '&entId=' + window.localStorage.getItem('entId'),
      }).then(res => {
        this.tableData = []
        if (res.Code == 0) {
          this.allPage = res.TotalCount
          this.tableData = res.Source.map(item => ({
            id: item.BH,
            img: item.ImgUrl,
            name: item.PrizeName,
            type: item.PrizeType,
            value: item.PrizeCount,
            lastTime: item.LastModifyTime,
          }))
        }
      }).catch((err) => {
        window.console.log(err);
      });
    },

    /**获取积分商城商品 */
    getGoods() {
      this.goodsDialog = true
      let data = {
        Procedure: 'Proc_Integral',
        Type: 'Integral_Goods_Select',
        Goodsname: this.goodsName,
        Status: '999',
        Floottype: '',
        PageIndex: '1',
        PageSize: '100',
      }
      let type = "DataTable"
      this.$requestSys({
        url: "Integral/ashx/ReturnDataTable.ashx?Type=" + type + "&Json=" + encodeURIComponent(JSON.stringify(data)),
        method: "post",
      }).then((res) => {
        if (res.return_code == 0) {
          this.goodsList = res.data
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },

    /**选中商品 */
    handleGoods({row}) {
      this.addForm.value = row.goodsid
      this.addForm.name = row.goodsname
      this.addForm.img = row.img_url
      this.goodsDialog = false
    },

    // 获取奖品类型
    getType() {
      this.$request({
        method: 'get',
        url: 'Prize/PrizeType',
      }).then(res => {
        if (res.Code == 0) {
          this.typeList = res.Source
          this.addForm.type = this.typeList[0]
        }
      }).catch((err) => {
        window.console.log(err);
      });
    },
    /**刷新数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData()
    },
    handleEdit(row) {
      this.clearForm()
      if (row) {
        this.addForm.id = row.id
        this.addForm.type = row.type
        this.addForm.name = row.name
        this.addForm.img = row.img
        this.addForm.coupon = row.value
        this.addForm.value = row.value
      }

      this.addDrawer = true;
    },
    handleDel(row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$request({
          method: "post",
          url: "Prize/DeletePrize?code=" + row.id,
        }).then((res) => {
          if (res.Code == 0) {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getTableData()
          } else {
            this.$message({
              message: res.Message,
              type: 'error'
            });
          }
        }).catch((err) => {
          window.console.log(err)
        });
      }).catch(() => { });
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.addForm = { id: "", type: this.typeList[0], name: "", img: "", coupon: "", value: "" }
      this.addDrawer = false;
    },
    uploadImg(file) {
      if (file.length) {
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append('file', file[i]);
        }
        this.$uploadRequest({
          url: 'admin/LuckyDraw/ashx/PrizePictureUpload.ashx',
          method: "post",
          data: fileData
        }).then((res) => {
          console.log(res);

          if (res.return_code == 0) {
            this.addForm.img = (res.data && res.data[1] && res.data[1].picture) || this.addForm.img
            this.$message({
              message: '图片上传成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: (res.data && res.data[0] && res.data[0].message) || '上传失败',
              type: 'error'
            });
          }
        }).catch((err) => {
          window.console.log(err);
        });
      }
    },
    // 获取弹出框表格数据
    getCoupon(val) {
      this.searchCoupon.name = val || this.searchCoupon.name
      let data = {
        type: "Pc_GetCoupon",
        PageIndex: this.currPageCoupon,
        PageSize: 10,
        couponName: this.searchCoupon.name,
        sltGZ: "99",
        sltSB: "99",
        sltLQ: "99",
        sltCJ: "99",
        status: "1",
        couponCode: ""
      };
      let proc = "Pc_Coupon"//存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        // 河药上面那个通用接口不能用，换成article开头的接口了
        // url: "coupon/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
        url: "/article/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
        data: data
      }).then((res) => {
        if (res.flag == 0) {
          this.tableList = res.data
          this.tableDataHead = { couponCode: '编号', couponName: '名称', couponsNumber: '数量', coupontype: '类型', deduction: '价值', receivingType: '领取类型', sceneName: '使用范围' }
          this.allPageCoupon = res.recordCount
          this.dialogVisible = true
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch((err) => {
        window.console.log(err)
      });
    },
    /**当前页改变 */
    hanCurrChangeCoupon(val) {
      this.currPageCoupon = val;
      this.getCoupon()
    },
    // 选择单条数据
    rowClick(row) {
      this.addForm.coupon = row.couponCode
      this.addForm.name = row.couponName
      this.dialogVisible = false
    },
    /**提交表单 */
    submit() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          let data = {
            BH: this.addForm.id,
            entId: window.localStorage.getItem('entId'),
            ImgUrl: encodeURI(this.addForm.img),
            PrizeName: this.addForm.name,
            PrizeType: this.addForm.type,
            PrizeCount: this.addForm.type == '优惠券' ? this.addForm.coupon : this.addForm.value
          };
          this.$request({
            method: "post",
            url: 'Prize/UpdatePrize',
            data: data
          }).then((res) => {
            if (res.Code == 0) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getTableData()
              this.clearForm()
            } else {
              this.$message({
                message: res.Message,
                type: 'error'
              });
            }
          }).catch((err) => {
            window.console.log(err)
          });
        } else {
          this.$message({
            message: '请补全信息',
            type: 'warning'
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.prizeList {
  width: 100%;
  height: 100%;
}
</style>
